import { api } from './apiClient';
import type { PublicLobby } from '@/types/lobby';

interface LobbyResponse {
  lobby: PublicLobby;
}

interface LeaveResponse {
  lobbyDeleted: boolean;
  lobbyId: string;
}

/**
 * HTTP client for the backend's `/api/lobby` routes
 * (see `cobstream-backend/src/services/lobby/lobby.routes.ts`).
 *
 * Note: the backend does NOT expose a `/api/lobby/me` shortcut today, so
 * `getLobbyById` is used to validate a locally-persisted lobby on app boot.
 */
export const lobbyApi = {
  create(): Promise<LobbyResponse> {
    return api<LobbyResponse>('/api/lobby', { method: 'POST', auth: true });
  },
  join(lobbyCode: string): Promise<LobbyResponse> {
    return api<LobbyResponse>('/api/lobby/join', { method: 'POST', body: { lobbyCode }, auth: true });
  },
  leave(lobbyId: string): Promise<LeaveResponse> {
    return api<LeaveResponse>(`/api/lobby/${encodeURIComponent(lobbyId)}/leave`, {
      method: 'DELETE',
      auth: true,
    });
  },
  getLobbyById(lobbyId: string): Promise<LobbyResponse> {
    return api<LobbyResponse>(`/api/lobby/${encodeURIComponent(lobbyId)}`, { auth: true });
  },
};
